import { getAllTemplateService } from "@/services/getAllTemplatesService";
import { useQuery } from "@tanstack/react-query";

function useTemplates() {
  return useQuery({
    queryKey: ["template"],
    staleTime: 1000 * 60 * 10,
    retry: 2,
    retryDelay: 1000,
    queryFn: getAllTemplateService,
  });
}

export default useTemplates;
